export const enum BillingStatusEnum {
  Unverified = 1,
  Verified = 2,
  Billed = 3,
  Rejected = 4,
  Denied = 5,
  Closed = 6,
  Processing = 7,
  Pending = 8,
  Refund = 9
}



// WEBPACK FOOTER //
// ./src/app/core/enums/billing-status.enum.ts